export default function Translations(string) {
  const language = require('./languages/en.json');
  if (!language[string]) {
    console.warn('String not found: ', string);
  }
  return language[string];
};